import { isWithdrawnOrder, type PresentedOrderSetDto } from "@/lib/order-set-presentation";
import { qualifiedProcedureTitle } from "@/shared/lib/procedure-title";
import { TimelineProcedureRow } from "@/shared/timeline";
/** Individual procedure rows inside their timed step. */
export function StepProcedures({
  steps,
  stepId,
  editable,
  onRemove,
  onSplit,
}: {
  steps: PresentedOrderSetDto["steps"];
  stepId: string;
  editable: boolean;
  onRemove?: (orderId: string) => void;
  onSplit?: (orderId: string) => void;
}) {
  const step = steps.find((item) => item.stepId === stepId);
  if (!step) return null;
  const orders = step.orders.filter((order) => !isWithdrawnOrder(order));
  return (
    <fieldset aria-label={`Step ${steps.indexOf(step) + 1} procedures`} className="min-w-0 space-y-0.5">
      {orders.map((order) => (
        <TimelineProcedureRow
          key={order.orderId}
          procedure={{
            id: order.orderId,
            title: qualifiedProcedureTitle(order.definition.title, order.qualifier),
            completed: order.status === "completed",

            statusLabel: order.status === "revoked" ? "Did not perform" : undefined,
          }}
          stepId={stepId}
          editable={editable && order.status !== "revoked"}
          onRemove={order.status !== "revoked" ? onRemove : undefined}
          onSplit={orders.length > 1 && order.status !== "revoked" ? onSplit : undefined}
        />
      ))}
      {orders.length === 0 && <p className="px-1.5 py-1 text-[11px] text-muted-foreground">No procedures</p>}
    </fieldset>
  );
}
